/**
 * Review environment = Lovable preview / staging / local hosts. Preview URLs
 * already require project access, so review languages never reach the
 * public production domain (fennest.com / fennest.lovable.app).
 */
export function isReviewEnvironment(hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  if (!hostname) return false;
  return (
    hostname === 'localhost' ||
    hostname.endsWith('.lovableproject.com') ||
    (hostname.includes('preview') && hostname.endsWith('.lovable.app'))
  );
}

export const LANGUAGE_STORAGE_KEY = 'fennest:language';

export function readStoredLanguage(): string | null {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeStoredLanguage(code: string) {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}
